import { Redo2, Save, Undo2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function EmptyFlatfinderEditor({
  busy,
  canEdit,
  canRedo,
  canSave,
  canUndo,
  perspectiveControls,
  onRedo,
  onSave,
  onUndo,
}: {
  busy: boolean;
  canEdit: boolean;
  canRedo: boolean;
  canSave: boolean;
  canUndo: boolean;
  perspectiveControls: React.ReactNode;
  onRedo: () => void;
  onSave: () => void;
  onUndo: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="min-w-0 rounded border bg-primary-lighter p-3">
      <div className="flex flex-wrap justify-between gap-2">
        {perspectiveControls}
        <div className="flex gap-2">
          <Button
            variant="ghost"
            aria-label={t('undo')}
            title={t('undo')}
            disabled={busy || !canEdit || !canUndo}
            onClick={onUndo}
          >
            <Undo2 />
          </Button>
          <Button
            variant="ghost"
            aria-label={t('redo')}
            title={t('redo')}
            disabled={busy || !canEdit || !canRedo}
            onClick={onRedo}
          >
            <Redo2 />
          </Button>
          {canSave ? (
            <Button className="gap-2" disabled={busy || !canEdit} onClick={onSave}>
              <Save />
              {t('save')}
            </Button>
          ) : null}
        </div>
      </div>
      <div className="flex min-h-72 items-center justify-center p-8 text-center text-text-secondary">
        {t('flatfinderWorkspaceAddImage')}
      </div>
    </div>
  );
}
